import { IconButton } from "@mui/material";

import { Dialog } from "@/modules/common/components/Dialog";
import { Icon } from "@/modules/common/components/Icon";
import { Typography } from "@/modules/common/components/Typography";
import { ENERGY_SHIFT_TARGET_YEAR } from "@/modules/common/constants";
import { useDialog } from "@/modules/common/hooks/useDialog";
import { TeamActionsRecap } from "@/modules/play/Components/TeamActionsRecap";
import { useCurrentPlayer } from "@/modules/play/context/hooks/player";
import { useTranslation } from "@/modules/translations";

export { TeamActionsHeader };

function TeamActionsHeader() {
  const { t } = useTranslation(["common", "countries"]);
  const { teamActionsAtCurrentStep } = useCurrentPlayer();
  const { isOpen, closeDialog, openDialog } = useDialog();

  return (
    <>
      <TeamActionsRecap
        teamActions={teamActionsAtCurrentStep}
        helper={
          <IconButton aria-label="help with current step" onClick={openDialog}>
            <Icon name="helper" sx={{ color: "white" }} />
          </IconButton>
        }
      />

      <Dialog open={isOpen} handleClose={closeDialog}>
        <Typography
          dangerouslySetInnerHTML={{
            __html: t("page.player.team-actions.help.step", {
              year: ENERGY_SHIFT_TARGET_YEAR,
            }),
          }}
        ></Typography>
      </Dialog>
    </>
  );
}
